import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Project from './views/Project.vue'
import Timeline from './views/Timeline.vue'
import About from './views/About.vue'

Vue.use(Router)

function sleep(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition //sleep(500).then(() => window.scrollTo(savedPosition.x, savedPosition.y))
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/project/:projectKey',
      name: 'project',
      props: true,
      component: Project
    },

    {
      path: '/timeline',
      name: 'timeline',
      component: Timeline
    },
    {
      path: '/about',
      name: 'about',
      component: About
    }
  ]
})
